import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <AppSidebar />
        <main className="flex-1 overflow-hidden bg-background transition-all duration-300 ease-in-out relative">
          {/* Add a subtle inset shadow to create depth */}
          <div className="absolute inset-0 pointer-events-none" style={{
            boxShadow: 'inset 6px 0 8px -4px rgba(0, 0, 0, 0.02)'
          }} />
          {children}
        </main>
      </div>
    </SidebarProvider>
  );
}